import type { FacilityResource } from "@lib/store";

type FacilitySummaryProps = {
  facility: FacilityResource;
};

// The facility's name, and where it is
export const FacilitySummary = ({ facility }: FacilitySummaryProps) => {
  return (
    <div className="flex flex-col gap-4">
      <h2 className="font-display text-[26px] font-medium leading-8">{facility.name}</h2>
      <p>{[facility.buildingName, facility.floorName].filter(Boolean).join(", ")}</p>
    </div>
  );
};
